import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { DffSideModule, EmptyPageBadgeModule, PanelModule } from "@dffedb/ui";
import { InstallationListeModule } from "@e-forsyning/common/installation";
import { NoteModule } from "@e-forsyning/common/note";

import { DeeplinkNoteComponent } from "./deeplink-note/deeplink-note.component";
import { DeeplinkRoutingModule } from "./deeplink-routing.module";
import { DeeplinkSideComponent } from "./deeplink-side/deeplink-side.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        DeeplinkRoutingModule,
        DffSideModule,
        PanelModule,
        EmptyPageBadgeModule,
        InstallationListeModule,
        NoteModule
    ],
    exports: [],
    declarations: [DeeplinkSideComponent, DeeplinkNoteComponent],
    providers: []
})
export class EForsyningFeaturesDeeplinkModule {}
